"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Globals = exports.baseFont = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\thtml {\n\t\tbox-sizing: border-box;\n\t\theight: 100%;\n\t}\t\n\t\n\t*, *::before, *::after {\n\t\tbox-sizing: inherit;\n\t}\n\t\n\tbody {\n\t\tfont-family: 'Roboto', sans-serif;\n\t\tfont-size: 16px;\n\t\tmargin: 0;\n\t\tmin-height: 100%;\n\t\toverflow-x: hidden;\n\t}\n\t\n\timg {\n\t\tdisplay: block;\n\t\tmax-width: 100%;\n\t}\n\t\n\tsvg {\n\t\tfill: currentColor;\n\t\twidth: 1em;\n\t\theight: 1em;\n\t\tdisplay: inline-block;\n\t\tfont-size: 24px;\n\t\ttransition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\t\tuser-select: none;\n\t\tflex-shrink: 0;\n\t}\n\t\n\tstrong, b {\n\t\tfont-weight: bold;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// @ts-ignore
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
var baseFont = "Roboto, sans-serif";
exports.baseFont = baseFont;
var Globals = (0, _styledComponents.createGlobalStyle)(_templateObject());
exports.Globals = Globals;